import React, { useState, useEffect } from 'react';
import { putGuestsDate, postInvitation } from 'services/rsvp/getRSVP';
import styles from './styles.module.scss';
import { useWindowSize } from 'hooks';

const MyGuestsDate = ({ typeId, fechainvitacion, onGetRefreshDate }) => {
  const [editFechaenvio, setEditFechaEnvio] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDateDB, setSelectedDateDB] = useState(null);
  const [inputValue, setInputValue] = useState('');
  const [, { isMobile }] = useWindowSize();
  // Función para cambiar el formato de la fecha
  const formatDate = (dateString) => {
    const parts = dateString.split('-');
    if (parts.length === 3) {
      const year = parts[0].slice(-2);
      const month = parts[1];
      const day = parts[2];
      return `${day}/${month}/${year}`;
    }
    return dateString;
  };

  const handleClickDate = () => {
    setEditFechaEnvio(true);
  };

  const handleDateChange = (e) => {
    const selectedDateValue = e.target.value;
    const currentDate = new Date();
    const unixTimestamp = Math.floor(currentDate.getTime() / 1000);
    const selectedDateunixTimestamp = Math.floor(new Date(selectedDateValue).getTime() / 1000);
    //  console.log('selectedDateValue ', selectedDateValue, 'currentDate: ',currentDate);
    // Validación de fecha
    if (selectedDateunixTimestamp < unixTimestamp) {
      alert ('No puedes seleccionar fechas anteriores o igual a la actual.');
      setEditFechaEnvio(false);
    } else {
      setSelectedDate(formatDate(selectedDateValue));
      setSelectedDateDB(selectedDateValue);
      setEditFechaEnvio(false);
    }
  };

  useEffect(() => {
    console.log('fechainvitacion',fechainvitacion);
    if (selectedDate) {
      if(fechainvitacion?.data?.items === undefined){
        const updatedData = {
          event_name: "",
          event_date: "",
          time: "",
          celebrate_name: "",
          address: "",
          message: "",
          giftTableId: typeId,
          catalog_invitation_template_id: "",
          celebrate_last_name: "",
          scheduled_invitation_delivery_date: selectedDateDB
        };
        postInvitation(typeId, updatedData).then((valorDeServicio) => {
          console.log('Guarda Fecha Envio postInvitation ', valorDeServicio);
        });
      }else{
        const updatedData = { fecha: selectedDateDB };
        putGuestsDate(typeId, updatedData).then((valorDeServicio) => {
          //console.log('putGuestsDate ', valorDeServicio);
        });
      }
      //console.log('Actualiza fecha de envío: ', selectedDateDB);

      onGetRefreshDate();
    }
  }, [selectedDate]);

  return (
    <div>
      {!isMobile ? (
      <div className="row align-items-center">
        <div className='col-md-10 col-12 text-md-left text-center'>
          <b className="text-md-left text-center mb-2">Envío de invitación programado </b><br />
          <b className="text-md-left text-center">para :</b>
        </div>
        <div className='col-md-2 col-12 text-md-right text-center mb-2'>
          <i
            className='fa fa-pencil fa-lg'
            onClick={handleClickDate}
            style={{ cursor: 'pointer', color: 'red' }}
          ></i>
        </div>
      </div>
      ):(
        <div className="row ">
          <div className='col-md-10 col-10 text-left'>
          <b className="text-md-left mb-2">Envío de invitación</b><br />
          <b className="text-md-left ">programado para :</b>
          </div>
          <div className='col-md-2 col-2'>
            <i
              className='fa fa-pencil fa-lg'
              onClick={handleClickDate}
              style={{ cursor: 'pointer', color: 'red' }}
            ></i>
          </div>
        </div>
      )}

      <br />
      <div className="row">
        <div className='col-md-3 col-12 text-md-left text-left'>
          <b>Fecha</b><br />

          {editFechaenvio ? (
            <input
              selected={selectedDate}
              onChange={(e) => setInputValue(e.target.value)}
              onBlur={handleDateChange}
              defaultValue={fechainvitacion?.data?.items}
              //dateFormat={selectedDate}
              type="date"
            />
          ) : (
            <span>{fechainvitacion?.data?.items}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default MyGuestsDate;
